export const getErrorForName = (errors, name) => {
  if (!errors) {
    return null;
  }

  if (errors[name]) {
    return errors[name];
  }

  if (name.includes('.')) {
    const split = name.split('.');

    if (errors[split[0]]) {
      let tmp = errors[split[0]];
      for (let i = 1; i < split.length; i += 1) {
        if (tmp[split[i]]) {
          tmp = tmp[split[i]];
        } else {
          tmp = null;
          break;
        }
      }

      if (tmp) {
        return tmp;
      }
    }
  }

  return null;
};

export const hasError = (errors, name) => {
  return !!getErrorForName(errors, name);
};

export const getHelpOrError = (help, errors, name) => {
  const error = getErrorForName(errors, name);

  if (error) {
    return error;
  }

  if (help) {
    return help;
  }

  return null;
};
